import React from "react"
import {useParams} from "react-router-dom"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useAccessToken} from "../../services/auth"
import {OkDocument} from "../../resources/common"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {
	getProductApplication,
	isBusinessProductApplicationDocument,
	isIndividualProductApplicationDocument,
	ProductApplication,
} from "../../resources/productApplication"
import BusinessProductApplication from "./BusinessProductApplication"
import IndividualProductApplication from "./IndividualProductApplication"

function ProductApplicationInternal({
	productApplicationDocument,
	refresh,
}: {
	productApplicationDocument: OkDocument<ProductApplication>
	refresh: () => void
}) {
	if (isBusinessProductApplicationDocument(productApplicationDocument)) {
		return <BusinessProductApplication productApplicationDocument={productApplicationDocument} refresh={refresh} />
	}
	if (isIndividualProductApplicationDocument(productApplicationDocument)) {
		return <IndividualProductApplication productApplicationDocument={productApplicationDocument} refresh={refresh} />
	}
	return <React.Fragment />
}

export default function ProductApplicationPage() {
	const {productApplicationId = ""} = useParams<{productApplicationId: string}>()
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const asyncResultApplication = useAsyncResult(
		() => getProductApplication(accessToken, productApplicationId),
		[refreshToken]
	)

	return (
		<AsyncResultComponent asyncResult={asyncResultApplication} refresh={refresh}>
			{({value}) => {
				return <ProductApplicationInternal productApplicationDocument={value} refresh={refresh} />
			}}
		</AsyncResultComponent>
	)
}
